import { Esqueleto } from '@/shared/ui/Esqueleto.jsx'

/** Placeholder com a MESMA geometria do card real, para a grade não pular. */
export function CardProdutoEsqueleto({ variante }: { variante: 'nova' | 'usada' }) {
  if (variante === 'nova') {
    return (
      <li className="flex flex-col overflow-hidden rounded-2xl bg-white shadow-xs">
        <Esqueleto className="h-64 rounded-none" />
        <div className="flex grow flex-col p-6">
          <Esqueleto className="mb-2 h-6 w-3/4" />
          <Esqueleto className="mb-1 h-4 w-full" />
          <Esqueleto className="mb-4 h-4 w-2/3" />
          <div className="mt-auto">
            <Esqueleto className="mb-4 h-8 w-32" />
            <Esqueleto className="h-12 w-full rounded-xl" />
          </div>
        </div>
      </li>
    )
  }

  return (
    <li className="flex flex-col overflow-hidden rounded-xl border border-gray-100 bg-gray-50">
      <Esqueleto className="h-48 rounded-none" />
      <div className="flex grow flex-col p-5">
        <Esqueleto className="mb-1 h-5 w-3/4" />
        <Esqueleto className="mb-3 h-4 w-full" />
        <Esqueleto className="mb-3 h-6 w-24" />
        <Esqueleto className="h-11 w-full rounded-lg" />
      </div>
    </li>
  )
}
